"use client";

/**
 * Thin mock-data context. Live sessions never import provider.tsx /
 * simulation-store — those stay behind the demo-only dynamic slot.
 */
import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
import { DEFAULT_DEMO_SCRIPT_STATE, DEFAULT_MOCK_CONFIG, DEFAULT_STUDIO_CONFIG, type LivePnLState, type MockDataContextValue } from "./types";
export const MockDataContext = createContext<MockDataContextValue | undefined>(undefined);
function disabledMockData(): MockDataContextValue {
  return {
    config: {
      ...DEFAULT_MOCK_CONFIG,
      enabled: false
    },
    isEnabled: false,
    isPanelOpen: false,
    setPanelOpen: () => {},
    livePnL: new Map(),
    simulation: {
      isRunning: false,
      type: null,
      startTime: null,
      config: null,
      progress: 0,
      lastEvent: null
    },
    startLivePnL: () => {},
    stopLivePnL: () => {},
    resetMockData: () => {},
    triggerMockTrade: () => {},
    updateConfig: () => {},
    setPnLPreset: () => {},
    setUpdateSpeed: () => {},
    addPositions: () => {},
    clearAllPositions: () => {},
    startSimulation: () => {},
    stopSimulation: () => {},
    countdown: 0,
    studioConfig: DEFAULT_STUDIO_CONFIG,
    demoScriptState: DEFAULT_DEMO_SCRIPT_STATE,
    applyScenarioPreset: () => {},
    startDemoScript: () => {},
    pauseDemoScript: () => {},
    resumeDemoScript: () => {},
    stopDemoScript: () => {},
    jumpToScriptStep: () => {},
    advanceScriptStep: () => {},
    setPresenterMode: () => {},
    setCtaOverlay: () => {}
  };
}
export function useMockData() {
  const $ = _c(1);
  const context = useContext(MockDataContext);
  if (context === undefined) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = disabledMockData();
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  return context;
}
export function useIsMockDataEnabled() {
  return useMockData().isEnabled;
}
export function useLivePnL(positionId) {
  const $ = _c(3);
  const {
    livePnL: pnlMap,
    isEnabled
  } = useMockData();
  if (!isEnabled) {
    return null;
  }
  let t0;
  if ($[0] !== pnlMap || $[1] !== positionId) {
    t0 = pnlMap.get(positionId) || null;
    $[0] = pnlMap;
    $[1] = positionId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function useAllLivePnL() {
  const $ = _c(1);
  const {
    livePnL: pnlMap,
    isEnabled
  } = useMockData();
  if (!isEnabled) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = new Map();
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  return pnlMap;
}